import React from "react";
import { motion } from "motion/react";

function PublishmentCard({ publishment }) {
  return (
    <div   className="w-11/12 mx-auto border-2 rounded-lg  overflow-hidden">
      <div className="relative group">
        <img
          loading="lazy"
          style={{ aspectRatio: "16/9" }}
          className="w-full rounded-md shadow-md object-cover h-[300px]"
          src={process.env.REACT_APP_IMG_URL + publishment.image}
          alt=""
        />
        <div
         className="absolute inset-0 duration-700 opacity-0 group-hover:opacity-100 group-hover:cursor-pointer group-hover:bg-gradient-to-tl from-teal-800/70 via-slate-900/30 to-transparent "></div>
      </div>
      <div className="flex justify-center w-full items-center mt-3">
        <motion.button
          whileFocus={{ outline: "dashed #000" }}
          whileTap={{ scale: 0.9 }}
          className="text-gray-900 duration-700  hover:bg-slate-900 hover:text-white border-2 px-5 py-2 rounded-md border-gray-300 w-full"
        >
          <h1>{publishment.title?.length>40 ? publishment.title.slice(0, 40) + "..." : publishment.title }</h1>
        </motion.button>
      </div>
    </div>
  );
}

export default PublishmentCard;
